<template>
  <div class="title">
    <div class="title__breadcrumb">
      Dashboard <span v-if="selectedRoom"> <span class="ficon chevron"></span>
        Raum {{ selectedRoom != null ? selectedRoom : 'No room selected' }}
      </span>
    </div>
    <h1 v-if="exhibitionsLoaded" class="title__main">
      {{ exhibitions.find(x => x.id === selectedExhibition).name  }}
    </h1>
  </div>
</template>

<script>
export default {
  name: 'Title',
  computed: {
    exhibitions() {
      return this.$store.state.exhibitions;
    },
    selectedExhibition() {
      // return this.$store.state.selectedExhibition;
      return this.$route.params.selectedProject;
    },
    exhibitionsLoaded() {
      return this.$store.state.exhibitionsLoaded;
    },
    selectedRoom() {
      return this.$store.state.selectedRoom;
    },
  },
};
</script>

<style scoped lang='scss'>
  .title {
    width: 100%;
    margin: .5rem 0;

    &__breadcrumb {
      margin: .5rem 0;

      .chevron {
        margin: 0 .25rem;
      }
    }

    &__main {
      padding: 0;
      margin: .5rem 0;
    }
  }
</style>
